var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOutbuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "#7DFF8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28292 8.256H11.9402C12.1371 7.69467 12.1973 7.09409 12.1156 6.50458C12.034 5.91508 11.8129 5.35383 11.471 4.86789C11.1291 4.38195 10.6763 3.98548 10.1505 3.71171C9.62466 3.43794 9.04123 3.29485 8.44908 3.29443H4.81396V5.77456H9.28292V8.256Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28277 8.25601H4.81382V5.77457H2.15784C1.95941 6.33578 1.89806 6.9367 1.97897 7.52672C2.05987 8.11675 2.28066 8.67859 2.62273 9.16492C2.96481 9.65126 3.41815 10.0478 3.94457 10.3213C4.471 10.5947 5.05509 10.737 5.64765 10.7361H9.28277V8.25601Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutbuild);
export default __webpack_public_path__ + "static/media/icon--outbuild.56ee3c7e60b11e96ea33ffff5675a929.svg";
export { ForwardRef as ReactComponent };